export default {
      id: "circle___geozone_circle_hidden-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle___geozone_circle_hidden",
      toString: function () {
        return this.url;
      }
    }